import { onError, onSuccess } from "../../../../utils/http";
import { errorNotification, successNotification } from "../../../../utils/notification";
import {
    DELETE_RT_PROJECT_CLIENT,
    GET_ALL_RT_PROJECT_CLIENT,
    POST_RT_PROJECT_CLIENT,
    PUT_RT_PROJECT_CLIENT,
    SET_ALL_RT_PROJECT_CLIENT,
} from "../../constants";

import { FINANCIAL_RT_ENDPOINT } from "../../constants/endpoint";

export const getAllProjectClient = () => {
    return {
        type: GET_ALL_RT_PROJECT_CLIENT,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/projectClient`,
        },
        meta: {
            onSuccess: (response, requestAction, store) => {
                store.dispatch(setAllProjectClient(response.data));
                return response;
            },
        },
    };
};

export const setAllProjectClient = (data) => {
    return {
        type: SET_ALL_RT_PROJECT_CLIENT,
        payload: data,
    };
};

export const postProjectClient = (projectClient) => {
    return {
        type: POST_RT_PROJECT_CLIENT,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/projectClient`,
            method: 'post',
            data: projectClient
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "create_success");
                store.dispatch(getAllProjectClient());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "create_error");
                throw error;
            })
        }
    };
};

export const putProjectClient = (id, projectClient) => {
    return {
        type: PUT_RT_PROJECT_CLIENT,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/projectClient/${id}`,
            method: 'put',
            data: projectClient
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "update_success");
                store.dispatch(getAllProjectClient());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "update_error");
                throw error;
            })
        }
    };
};

export const deleteProjectClient = (id) => {
    return {
        type: DELETE_RT_PROJECT_CLIENT,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/projectClient/${id}`,
            method: 'delete'
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "delete_success");
                store.dispatch(getAllProjectClient());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', error.response.status === 409 ? "ressource_in_use_error" : "delete_error");
                throw error;
            })
        }
    };
};